import { AppUpdateNotice } from '@jaluzi/ui';
import { useTranslation } from 'react-i18next';
import { appUpdate } from '../lib/app-update.js';

export function AppUpdate() {
  const { i18n } = useTranslation();
  return <AppUpdateNotice update={appUpdate} language={i18n.language} field />;
}
